




import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import { useCaptcha } from '~/composables';

export default defineComponent({
    name: 'CloudFlareCaptcha',
    props: {
        visible: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, { emit }) {
        const captchaRef = ref<HTMLElement | null>(null);
        const { siteKey, validateCaptcha } = useCaptcha();

        const loadScript = () => {
            return new Promise<void>((resolve) => {
                const scriptSrc = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
                const existing = document.querySelector(`script[src="${scriptSrc}"]`);

                if (existing) return resolve();

                const script = document.createElement('script');
                script.src = scriptSrc;
                script.async = true;
                script.onload = () => resolve();
                document.head.appendChild(script);
            });
        };

        const renderCaptcha = () => {
            if ((window as any).turnstile && captchaRef.value) {
                (window as any).turnstile.render(captchaRef.value, {
                    sitekey: siteKey(props.visible),
                    callback: async (token: string) => {
                        const result = await validateCaptcha(token, props.visible);
                        emit('result', result);
                    },
                });
            }
        };

        onMounted(async () => {
            if (!props.visible) return;
            await loadScript();
            renderCaptcha();
        });

        return {
            captchaRef,
        };
    },
});
